import { useEffect, useRef } from "react";
import { renewTokens } from "../calls/apiCalls";
import { getRefreshToken } from "../utils/authStorage";

const IDLE_MS = 12 * 60 * 60 * 1000; // 12 hours

export default function useIdleSession() {
  const lastActivity = useRef(Date.now());

  useEffect(() => {
    const mark = () => {
      lastActivity.current = Date.now();
    };

    const events = ["mousemove", "keydown", "click", "touchstart", "scroll"];
    events.forEach((event) =>
      window.addEventListener(event, mark, { passive: true }),
    );

    const id = setInterval(
      () => {
        if (!getRefreshToken()) return;
        if (Date.now() - lastActivity.current < IDLE_MS) {
          renewTokens().catch(() => {});
        }
      },
      10 * 60 * 1000,
    );

    return () => {
      events.forEach((event) => window.removeEventListener(event, mark));
      clearInterval(id);
    };
  }, []);
}
